/**
 * Returns a promise that will retry the given function if retry is called.
 */
export function retryableLoad<T>(loadFn: () => Promise<T>): {
  retry: () => void;
  promise: Promise<T>;
} {
  let retryRequested = false;
  function runLoad(): Promise<T> {
    return loadFn().then((result: T) => {
      if (retryRequested) {
        retryRequested = false;
        return runLoad();
      }
      return result;
    });
  }
  return {
    retry: () => {
      retryRequested = true;
    },
    promise: runLoad(),
  };
}
